import React from "react";
import HealthSupportBannerSrc from "../assets/img/health-support/Health-Support-Header-Banner_2560x600_ret.jpg";
import HealthSupportBannerSrcMobile from "../assets/img/health-support/Health-Support-Header-Banner-mobile-640x300.jpg";
//import HealthSupportBannerHolSrc from "../assets/img/hol/customer-offers.jpg";
import { Paths } from "../constants/UrlConstants";
import HeartSrc from "../assets/img/card-images/heart-blue.svg";
import Helpline247Src from "../assets/img/card-images/24-7-helpline.svg";
import QuestionSrc from "../assets/img/card-images/help-woman-blue.svg";
import MedKitSrc from "../assets/img/card-images/health-kit-blue.svg";
import InjuredSrc from "../assets/img/card-images/plaster-crutch-blue.svg";
import ContactUsSrc from "../assets/img/card-images/email-blue.svg";
import SpeakToTeamSrc from "../assets/img/card-images/phone-blue.svg";
import { getPhone, getOpeningHours } from "../helpers/ContentStateHelper";
import style from "../assets/css/modules/health-support/health-support.css";
import CancerSrc from "../assets/img/card-images/cancer-diagnosis.svg";
import OnlineGPSrc from "../assets/img/card-images/online-gp.svg";
import TreatmentSrc from "../assets/img/card-images/treatment-icon.svg";
import HealthierLifeScr from "../assets/img/card-images/gym.svg";
import { ButtonConfig } from "../constants/Constants";

const askMedicalExpert = {
  Question: "When can I expect to hear back from a medical expert?",
  Answer: {
    Any:
      (
        <p>
          Give us a call and we can arrange a call back at a time convenient for
          you. Or send us a question and we aim to get back to you within 24 hours.
        </p>
      ),
    HOL:
      (
        <p>
          Give us a call and we can arrange a call back at a time convenient for you. Or send us a question and we aim to get back to you within 24 hours.
        </p>
      )
  }
};

const bookFastTrackAppointment = {
  Question: "How do I book a Specialist Appointment?",
  Answer: {
    Any: (
      <React.Fragment>
        <p>
          You will need an open referral from your GP. Once you have this, give us
          a call and we will check you are covered and authorise eligible
          treatment as specified by your GP.
        </p>
        <p>
          We will then find you 3 Specialists in the postcode area you want to be
          seen and contact the hospital or Specialist's secretary to make a
          suitable appointment for you.
        </p>
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <p>
          You will need an open referral from your GP. Once you have this, give us 
          a call and we will check you are covered and authorise eligible 
          treatment as specified by your GP.
        </p>
        <p>
          We will then find you 3 Specialists in the postcode area you want to be 
          seen and contact the hospital or Specialist's secretary to make a 
          suitable appointment for you.
        </p>
      </React.Fragment>
    )
  }
};

const healthyLifeSupportItemLinks = {
  LinkTo: Paths.HealthStore,
  LinkText: {
    Any: "Member offers",
    HOL: "Customer offers"
  },
};
const askMedExpertLink = {
  LinkTo: Paths.AskAMedicalExpert,
  LinkText: {
    Any: "24/7 health support line",
    HOL: "24/7 health support line"
  },
  id:ButtonConfig.HealthSupportLineRecover
};
const healthInformationLink = {
  LinkTo: Paths.HealthInformation,
  LinkText: "Health information"
};

const workingBodyLink = {
  LinkTo: Paths.WorkingBody,
  LinkText: "Speak to a physiotherapist",
  id:ButtonConfig.SpeakToAPhysiotherapist
};
const gpAppointmentsLink = {
  LinkTo: Paths.GPAppointments247,
  LinkText: "GP Appointments 24/7",
  id:ButtonConfig.GPAppointments247Unwell
};
const fastTrackAppointmentsLink = {
  LinkTo: Paths.FastTrack,
  LinkText: "Specialist Appointment Booking Service",
  id:ButtonConfig.SpecialistAppointmentBookingService
};
const check4CancerLink = {
  LinkTo: Paths.Check4Cancer,
  LinkText: "Prostate cancer diagnostic service"
};
const prostatecancerdiagnosticservicesItemLink = {
  LinkTo: Paths.Check4CancerProstate,
  LinkText: "Prostate cancer diagnostic service",
  id:ButtonConfig.ProstateCancerDiagnosticService
};
const skincancerdiagnosticservicesItemLink = {
  LinkTo: Paths.Check4CancerSkin,
  LinkText: "Skin cancer diagnostic service",
  id: ButtonConfig.SkinCancerDiagnosticService
};
const breastcancerdiagnosticservicesItemLink = {
  LinkTo: Paths.Check4CancerBreast,
  LinkText: "Breast cancer diagnostic service",
  id:ButtonConfig.BreastCancerDiagnosticService
};
const physiotherapistLink = {
  LinkTo: Paths.WorkingBody,
  LinkText: "Speak to a physiotherapist",
  id:ButtonConfig.SpeakToAPhysiotherapist
};

const healthyLifeSupportItem = {
  IconSrc: {
    Any: HeartSrc,
    HOL: HealthierLifeScr
  },
  Heading: {
    Any: "I want to live a healthier life",
    HOL: "I want to live a healthier life"
  },
  Desc: {
    Any: "Keep fit for less with our special gym offer or explore your health and lifestyle with a discounted health assessment.",
    HOL: "Keep fit for less with our special gym offer or explore your health and lifestyle with a discounted health assessment."
  },
  Links: {
    Any: [healthyLifeSupportItemLinks],
    SMEModular: [healthyLifeSupportItemLinks],
    HOL: [healthyLifeSupportItemLinks]
}
};

const cancerdiagnosticservicesSupportItem = {
  IconSrc: CancerSrc,
  Heading: "Cancer diagnostic services",
  Desc:
    "We know that when you're worried about a potential cancer, speed and reassurance are really important.",
  Links: {
    Any: [breastcancerdiagnosticservicesItemLink, skincancerdiagnosticservicesItemLink, prostatecancerdiagnosticservicesItemLink]
  }
};

const worriedSupportItem = {
  IconSrc: {
    Any: QuestionSrc,
    HOL: Helpline247Src,
  },
  Heading: "I'm worried there might be something wrong",
  HeadingFlag:"worried",
  Desc: {
    Any: "If you're worried that there might be something wrong, or you are unsure about something related to your health, we're here to support and guide you.",
    HOL: "Being kept awake at night worrying about a recent diagnosis or upcoming surgery or you are unsure about something related to your health, we're here to support and guide you."
  },
  Links: {
    Any: [
      gpAppointmentsLink,
      healthInformationLink,
      askMedExpertLink,
    ],
    Saga: [askMedExpertLink, healthInformationLink, check4CancerLink],
    HOL: [
      gpAppointmentsLink,askMedExpertLink,prostatecancerdiagnosticservicesItemLink//check4CancerLink
    ]
  }
};

if (!window?.axa?.features?.healthUnlockedFeature) {
  worriedSupportItem.Links.Any.splice(1, 1);
  worriedSupportItem.Links.Saga.splice(1, 1);
}

const unwellSupportItem = {
  IconSrc: {
    Any: MedKitSrc,
    HOL: OnlineGPSrc
  },
  Heading: "I'm unwell and considering treatment",
  HeadingFlag:"unwell",
  Desc:{
    Any: "When it comes to your health, saving time could save your life. If you or anyone in your family is unwell, we can help you get the right treatment quickly.",
    HOL: "When it comes to your health, saving time could save your life. If you or anyone in your family is unwell, we can help you get the right treatment quickly."
  },
  Links: {
    Any: [
      askMedExpertLink,
      workingBodyLink,
      gpAppointmentsLink,
      healthInformationLink,
      fastTrackAppointmentsLink,
    ],
    Saga: [
      askMedExpertLink,
      workingBodyLink,
      healthInformationLink,
      fastTrackAppointmentsLink,
      check4CancerLink
    ],
    HOL: [
      askMedExpertLink,
      gpAppointmentsLink,
      physiotherapistLink
    ]
  }
};

if (!window?.axa.features?.healthUnlockedFeature) {
  unwellSupportItem.Links.Any.splice(3, 1);
  unwellSupportItem.Links.Saga.splice(2, 1);
}

const unwellSupportItemWithoutFasttrack = {
  ...unwellSupportItem,
  Links: {
    Any: [
      askMedExpertLink,
      workingBodyLink,
      gpAppointmentsLink,
      healthInformationLink
    ]
  }
};

if (!window?.axa.features?.healthUnlockedFeature) {
  unwellSupportItemWithoutFasttrack.Links.Any.splice(3, 1);
}

const injuredSupportItem = {
  IconSrc: {
    Any: InjuredSrc,
    HOL: TreatmentSrc
  },
  Heading: "I'm having or recovering from treatment",
  HeadingFlag:"injured",
  Desc: {
    Any: "If you're having treatment or recovering from a recent treatment, we're here to help you on the road to recovery.",
    HOL: "If you're having treatment or recovering from a recent treatment, we're here to help you on the road to recovery."
  }, 
  Links: {
    Any: [askMedExpertLink, healthInformationLink],
    HOL: [askMedExpertLink]
  }
};

if (!window?.axa.features?.healthUnlockedFeature) {
  injuredSupportItem.Links.Any.splice(1, 1);
  injuredSupportItem.Links.HOL.splice(1, 1);
}

const healthSupportItems = {
  Any: [
    healthyLifeSupportItem,
    cancerdiagnosticservicesSupportItem,
    worriedSupportItem,
    unwellSupportItem,
    injuredSupportItem],
  Saga: [worriedSupportItem, unwellSupportItem, injuredSupportItem],
  LargeCorporate: [
    worriedSupportItem,
    cancerdiagnosticservicesSupportItem,
    unwellSupportItem,
    injuredSupportItem],
  Lapsed: [
    worriedSupportItem,
    unwellSupportItem,
    injuredSupportItem],
  HOL:[
    worriedSupportItem,
    unwellSupportItem,
    injuredSupportItem,
    healthyLifeSupportItem
  ]
};

const HealthSupport = {
  HeroContent: {
    Heading: {
      Any: "Health support",
      HOL: "Health hub"
    },
    Header: "How can we help you?",
    HealthSupportBannerSrc: {
      Any: null, // Use background color instead
      HOL: HealthSupportBannerSrc
    },
    HealthSupportBannerSrcMobile: {
      Any: null, // Use background color instead
      HOL: HealthSupportBannerSrcMobile
    },
    Body:
      "We're here to support you with your health, every step of the way. Explore how we can help you and your family below."
  },

  HealthSupportItems: healthSupportItems,
  HealthSupportItemsWithoutFasttrack: {
    ...healthSupportItems,
    Any: [
      healthyLifeSupportItem,
      worriedSupportItem,
      unwellSupportItemWithoutFasttrack,
      injuredSupportItem],
    Lapsed: [
      worriedSupportItem,
      unwellSupportItemWithoutFasttrack,
      injuredSupportItem]

  },

  Promo: {
    Description:
      "We're here to support you with your health, every step of the way. Explore how we can help you and your family.",
    Heading: {
      International: "Second medical opinion",
      HOL: "Access my health hub",
      Any: "Access health support"
    },
    LinkText: {
      International: "Discover",
      HOL: "Health hub",
      Any: "Health support"
    }
  },
  Cards: {
    ContactUs: {
      IconSrc: ContactUsSrc,
      Heading: "Contact us with your query",
      Description: {
        Any:
          "Can't find what you are looking for? Send us a secure message from your inbox.",
        HOL:
          "Can't find what you are looking for? Send us a secure message from your inbox."
      },
      LinkText: "Contact us",
      LinkTo: Paths.ContactUs,
      id:ButtonConfig.ContactUsButton
    },
    SpeakToTeam: {
      IconSrc: SpeakToTeamSrc,
      Heading: "Speak to one of our team",
      Description: {
        Any: (props, params) => (
          <React.Fragment>
            You can call us on{" "}
            <strong className={style.axaIconLink}>{getPhone(props)}</strong>
            <br />
            We're open {getOpeningHours(props)}
          </React.Fragment>
        ),
        HOL: (props, params) => (
          <React.Fragment>
            You can call us on <strong>0800 587 0956</strong>
            <br />
            We're open {getOpeningHours(props)}
          </React.Fragment>
        )
      }
    }
  },
  AskMedicalExpert: askMedicalExpert,
  BookFastTrackAppointment: bookFastTrackAppointment,
  HelpSet: [askMedicalExpert, bookFastTrackAppointment]
};

export default HealthSupport;

export let _links = {
  gpAppointmentsLink,
  healthInformationLink,
  askMedExpertLink,
  check4CancerLink,
  workingBodyLink,
  fastTrackAppointmentsLink,
  prostatecancerdiagnosticservicesItemLink,
  skincancerdiagnosticservicesItemLink,
  breastcancerdiagnosticservicesItemLink,
  physiotherapistLink
};

export let _gpAppointmentsLink = gpAppointmentsLink;
export let _workingBodyLink = workingBodyLink;
export let _physiotherapistLink = physiotherapistLink;